import { Cart, ReservationSummary } from '@shared/models/event-purchase.model';

export function parseInputLabel(el: any): { label: string; value?: string | number | null } {
  const value =
    el.eventLabels.inputLabels.name === 'DROPDOWN'
      ? el.eventLabels.eventLabelProperties.find((op: { id: number }) => op.id === Number(el.value))?.name
      : el.value;

  return { label: el.eventLabels.name, value: value };
}

export function convertCartIntoOldFormat(cart: Cart[]): ReservationSummary[] {
  const seatsDto: ReservationSummary[] = [];

  cart.forEach((category) => {
    const cat = category.categoryDetails;

    if (category.tickets.count) {
      if (category.tickets.details) {
        let nonMemberSeatCount = 0;
        let nonMemberPricePerItem, nonMemberDiscountPerItem;
        let memberSeatCount = 0;
        let memberPricePerItem, memberDiscountPerItem;

        category.tickets.details.forEach((el) => {
          if (el.membershipId === 0) {
            nonMemberSeatCount = el.count;
            nonMemberDiscountPerItem = el.price - (!!cat?.hasActiveEB ? (el.ebPrice ?? el.price) : el.price);
            nonMemberPricePerItem = el.price - nonMemberDiscountPerItem;
          } else {
            memberSeatCount = el.count;
            memberDiscountPerItem = el.price - (!!cat?.hasActiveEB ? (el.ebPrice ?? el.price) : el.price);
            memberPricePerItem = el.price - memberDiscountPerItem;
          }
        });

        seatsDto.push({
          memberSeatCount,
          nonMemberSeatCount,
          nonMemberPricePerItem,
          nonMemberDiscountPerItem,
          memberPricePerItem,
          memberDiscountPerItem,
          seatCount: memberSeatCount + nonMemberSeatCount,
          isEarlyBird: !!cat?.hasActiveEB,
          seatId: cat.id,
        });
      }
    }
  });

  return seatsDto;
}

export function filterTickets(data: Cart[]): Cart[] {
  return data
    .filter((item) => item.tickets.count > 0)
    .map((item) => ({
      ...item,
      tickets: {
        ...item.tickets,
        details: item.tickets.details.filter((detail) => detail.count > 0),
      },
    }));
}

const PENDING_CHECKOUT_KEY = 'pendingCheckout';

export interface PendingCheckout {
  eventId: number | string;
  returnUrl: string;
  cart: Cart[];
}

export function savePendingCheckout(eventId: number | string, returnUrl: string, cart: Cart[]): void {
  sessionStorage.setItem(PENDING_CHECKOUT_KEY, JSON.stringify({ eventId, returnUrl, cart }));
}

export function peekPendingCheckout(): PendingCheckout | null {
  const raw = sessionStorage.getItem(PENDING_CHECKOUT_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function takePendingCheckout(): PendingCheckout | null {
  const pending = peekPendingCheckout();
  sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
  return pending;
}
